import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useOrganizationSetup } from "@/app/useOrganizationSetup";
import { PanelPlaceholder } from "@/components/shared/layout/PanelPlaceholder";
import { AppShell } from "@/presentation/shell/AppShell";
import { SHELL_CONTENT_PANEL_CLASS } from "@/presentation/shell/ShellSidePanelFrame";

export function ShellRoute() {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const organizations = useOrganizationSetup(pathname, search, { loadDetails: false });
  return (
    <AppShell
      organizations={organizations}
      loadingFallback={
        <PanelPlaceholder
          className={SHELL_CONTENT_PANEL_CLASS}
          loading
          loadingLabel={t("common.loading")}
        />
      }
    />
  );
}
